var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.space)?_c('div',{staticClass:"mb-4"},[(_vm.space)?_c('StorageCard',{staticClass:"mt-8",attrs:{"label":_vm._f("titleCase")(_vm.$t('navbar.freeSpace')),"color":"upload","value":_vm.space}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }